import { useRef } from 'react';
import { useDrag, useDrop } from 'react-dnd';

interface DragItem {
  id: string;
  index: number;
}

interface DraggableRowProps {
  id: string;
  index: number;
  itemType: string;
  moveRow: (dragIndex: number, hoverIndex: number) => void;
  onDragStart: () => void;
  onDrop: () => void;
  children: React.ReactNode;
}

// Fila de tabla arrastrable (admin-list-drag-reorder) — usa el patrón
// estándar de react-dnd (hover reordena, drop persiste) sobre <tr>.
export function DraggableRow({ id, index, itemType, moveRow, onDragStart, onDrop, children }: DraggableRowProps) {
  const ref = useRef<HTMLTableRowElement>(null);

  const [, drop] = useDrop<DragItem>({
    accept: itemType,
    hover(item) {
      if (!ref.current || item.index === index) return;
      moveRow(item.index, index);
      item.index = index;
    },
  });

  const [{ isDragging }, drag] = useDrag({
    type: itemType,
    item: (): DragItem => {
      onDragStart();
      return { id, index };
    },
    end: onDrop,
    collect: (monitor) => ({ isDragging: monitor.isDragging() }),
  });

  drag(drop(ref));

  return (
    <tr ref={ref} className={isDragging ? 'opacity-40' : undefined}>
      {children}
    </tr>
  );
}

export function DragHandle() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 16 16"
      fill="currentColor"
      className="cursor-grab text-gray-300 dark:text-gray-600"
      aria-hidden="true"
    >
      <circle cx="5" cy="3" r="1.3" />
      <circle cx="11" cy="3" r="1.3" />
      <circle cx="5" cy="8" r="1.3" />
      <circle cx="11" cy="8" r="1.3" />
      <circle cx="5" cy="13" r="1.3" />
      <circle cx="11" cy="13" r="1.3" />
    </svg>
  );
}
